export function articleVideo() {
    $(".play-button").on("click", function () {
        let $parent = $(this).parent();
        $parent.addClass('show-video');
        $parent.find("video").attr("controls", "true");
        $parent.find("video")[0].play();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/articleVideo.js